export default __webpack_public_path__ + "static/media/boyblocksrug.14bacd0d.jpg";